import { completeExpiredTasks } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';

export function useCompleteExpiredTasks(
  responseFn: (data: { success: boolean }) => void | Promise<unknown>
) {
  const { mutate, error, status } = useMutate(
    ['complete-tasks'],
    (resourceId: string) => completeExpiredTasks(resourceId),
    responseFn as (data: unknown) => void | Promise<unknown>
  );

  return {
    completeExpiredMutate: mutate,
    completeExpiredError: error,
    completeExpiredStatus: status,
  };
}
